import { step1 } from './request/step1';
import { step2 } from './request/step2';
import { step3 } from './request/step3';
import { step4 } from './request/step4';
import { step5 } from './request/step5';
import { step6 } from './request/step6';
import { step7 } from './request/step7';
import { step8 } from './request/step8';
import { step9 } from './request/step9';
import { step10 } from './request/step10';
import { createRecord, updateRecord } from '../../api/request';
import { addDays, format } from 'date-fns';
import { debounce } from 'debounce';
import { fbq, gtag } from 'src/helpers/marketing';

declare global {
  interface Window {
    PaypleCpayAuthCheck: any;
  }
}

class Payple {
  PCD_PAY_TYPE?: string;
  PCD_PAY_WORK?: string;
  PCD_CARD_VER?: string;
  PCD_PAYER_AUTHTYPE?: string;
  payple_auth_file?: string;
  is_direct?: string;
  PCD_PAYER_NO?: string; // (선택) 가맹점 회원 고유번호 (결과전송 시 입력값 그대로 RETURN)
  PCD_PAYER_NAME?: string; // (선택) 결제자 이름
  PCD_PAYER_HP?: string; // (선택) 결제자 휴대폰 번호
  PCD_PAYER_EMAIL?: string; // (선택) 결제자 Email
  PCD_PAY_GOODS?: string; // (필수) 결제 상품
  PCD_PAY_TOTAL?: string; // (필수) 결제 금액
  PCD_PAY_TAXTOTAL?: string; // (선택) 부가세 (복합과세인 경우 필수)
  PCD_PAY_ISTAX?: string; // (선택) 과세여부 (과세: Y | 비과세(면세): N)
  PCD_PAY_OID?: string; // 주문번호 (미입력 시 임의 생성)
  PCD_REGULER_FLAG?: string; // (선택) 정기결제 여부 (Y|N)
  PCD_PAY_YEAR?: string; // (PCD_REGULER_FLAG = Y 일때 필수) [정기결제] 결제 구분 년도 (PCD_REGULER_FLAG : 'Y' 일때 필수)
  PCD_PAY_MONTH?: string; // (PCD_REGULER_FLAG = Y 일때 필수) [정기결제] 결제 구분 월 (PCD_REGULER_FLAG : 'Y' 일때 필수)
  PCD_TAXSAVE_FLAG?: string; // (선택) 현금영수증 발행 여부 (Y|N)
  PCD_SIMPLE_FLAG?: string; // 간편결제 여부 (Y|N)
  PCD_PAYER_ID?: string; // 결제자 고유ID (본인인증 된 결제회원 고유 KEY)
  PCD_RST_URL?: string; // 결제자 고유ID (본인인증 된 결제회원 고유 KEY)

  clientKey?: string; // 파트너 인증 - 클라이언트 키(clientKey)
  callbackFunction?: (res: any) => void;
}

export function toggleAccordion(obj: HTMLElement) {
  obj.parentElement.classList.toggle('active');
}

export function toggleCompanyTypeWrap(obj: HTMLElement) {
  const nextElement = obj.parentElement.nextElementSibling;

  if (!nextElement.classList.contains('active')) {
    for (const dom of document.querySelectorAll('.company-type-wrap')) {
      dom.classList.remove('active');
    }
  }

  nextElement.classList.toggle('active');
}

export function requestPage() {
  return {
    isLoading: false,
    userInput: this.$persist({
      // 첫 스텝에서 만들어진 Airtable record. 이후 스텝은 전부 이걸로 갱신한다.
      recordId: null,
      name: '',
      hp: '',
      requestType: '신규 법인설립',
      businessTypes: [],
      customBusinessType: '',
      companyType: '',
      companyArea: '',
      recommendOfficeYn: '',
      companyName: {
        kr: '',
        en: '',
      },
      capital: '0',
      freeRegistrationYn: 'N',
      taxConsultingYn: '',
      address: {
        add1: '',
        addr2: '',
        building: '',
      },
      feeAndTax: false,
    }).using(sessionStorage),
    currentPage: this.$persist(1).using(sessionStorage),
    reservedNextPage: this.$persist(null).using(sessionStorage),
    isOpenPopup: false,
    pay_type: '',

    init() {
      this.debouncedSave = debounce(this.save, 500);

      this.$watch('userInput.capital', (value, oldValue) => {
        const v = parseInt(value.replace(/,/g, ''));
        if (isNaN(v)) {
          this.userInput.capital = '0';
        } else {
          this.userInput.capital = new Intl.NumberFormat().format(v);
        }
      });

      this.$watch('userInput', (value) => {
        this.debouncedSave();
      });

      gtag('AW-16776503624/4nUFCOiGjPIZEMjC1L8-');
      fbq('Request_View');
      console.log('event 1');
    },

    initInput() {
      sessionStorage.removeItem('_x_userInput');
      sessionStorage.removeItem('_x_currentPage');
      sessionStorage.removeItem('_x_reservedNextPage');
    },

    expectedCompleteDate() {
      return format(addDays(new Date(), 4), 'MM월 dd일');
    },

    get businessTypes() {
      return [
        ...this.userInput.businessTypes,
        ...this.userInput.customBusinessType.split(','),
      ];
    },

    setCompanyArea() {
      let companyArea;

      if (
        /(서울특별시)/g.exec(this.userInput.address.addr1) !== null ||
        /경기도 (의정부시|구리시|하남시|고양시|수원시|성남시|안양시|부천시|광명시|과천시|의왕시|군포시|시흥시)/g.exec(
          this.userInput.address.addr1,
        ) !== null ||
        (this.userInput.address.sido === '경기도' &&
          /(호평동|평내동|금곡동|일패동|이패동|삼패동|다산동|수석동|지금동|도농동)/g.exec(
            this.userInput.address.bname,
          )) ||
        (this.userInput.address.sido === '인천광역시' &&
          /(강화군|옹진군)/g.exec(this.userInput.address.addr1) === null &&
          /(대곡동|불로동|마전동|왕길동|당하동|원당동|운남동|운복동|운서동|중산동|남북동|덕교동|을왕동|무의동|송도동)/g.exec(
            this.userInput.address.bname,
          ) === null &&
          /(청라동|송도동)/g.exec(this.customer.address.building) === null)
      ) {
        companyArea = '서울/경기/인천';
      } else {
        companyArea = '비과밀억제권역';
      }

      this.userInput.companyArea = companyArea;
    },

    get capitalAsNumber() {
      const n = parseInt(this.userInput.capital.replace(/,/g, ''));

      if (isNaN(n)) return 0;
      return n;
    },

    get totalUtilities() {
      return 20000 + this.registrationTax + this.educationTax;
    },

    get totalUtilitiesAsString() {
      return new Intl.NumberFormat().format(this.totalUtilities);
    },

    get registrationTax() {
      const tax =
        this.capitalAsNumber * 0.004 < 112500
          ? 112500
          : this.capitalAsNumber * 0.004;

      if (this.userInput.companyArea === '서울/경기/인천') {
        return Math.ceil(tax * 3);
      }

      return Math.ceil(tax);
    },

    get registrationTaxAsString() {
      return new Intl.NumberFormat().format(this.registrationTax);
    },

    get educationTax() {
      return Math.ceil(this.registrationTax * 0.2);
    },

    get educationTaxAsString() {
      return new Intl.NumberFormat().format(this.educationTax);
    },

    async moveNext(firstCall = true) {
      window.scrollTo(0, 0);

      if (this.currentPage === 2) {
        gtag('AW-16776503624/57sxCIbC4fEZEMjC1L8-');
        fbq('Request_Click2');
        console.log('event 3');
      }

      // recordId가 없으면 record가 아직 없다는 뜻이라 여기서 만들고, 실패하면 다음 스텝으로
      // 넘기지 않는다 — 넘겨버리면 record 없이 퍼널을 끝까지 돌게 되고, 그 뒤 save()는
      // recordId가 없어 전부 조용히 무시된다(=접수가 통째로 유실).
      if (this.currentPage === 1 && firstCall && !this.userInput.recordId) {
        // 생성이 끝나기 전에 다시 눌리면 record가 둘로 늘어난다.
        if (this.isLoading) {
          return;
        }

        this.isLoading = true;
        let recordId: string;
        try {
          const response = await createRecord({
            name: this.userInput.name,
            hp: this.userInput.hp,
            requestType: this.userInput.requestType,
          });
          recordId = response.data.recordId;
        } catch (e) {
          console.error('createRecord failed', e);
          alert('접수 처리 중 오류가 발생했습니다. 다시 시도해 주세요.');
          return;
        } finally {
          this.isLoading = false;
        }
        this.userInput.recordId = recordId;
        this.moveNext(false);
        return;
      }

      if (this.reservedNextPage) {
        this.currentPage = this.reservedNextPage;
        this.reservedNextPage = null;
      } else {
        this.currentPage++;
      }
    },
    movePrev() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    moveTo(pageNum: number, pageFrom?: number) {
      window.scrollTo(0, 0);

      this.reservedNextPage = pageFrom;
      this.currentPage = pageNum;
    },

    /**
     * isFinal은 최종 제출에서만 true. 중간 저장은 큐로 흘러가 실패해도 최종 제출이 전체를 다시
     * 채우지만, 최종 제출은 유실되면 안 돼서 서버가 동기로 저장한다.
     */
    async save(isFinal = false) {
      if (!this.userInput.recordId) {
        return;
      }

      await updateRecord(this.userInput.recordId, {
        isFinal,
        name: this.userInput.name,
        hp: this.userInput.hp,
        businessTypes: this.userInput.businessTypes,
        customBusinessType: this.userInput.customBusinessType,
        companyType: this.userInput.companyType,
        companyArea: this.userInput.companyArea,
        recommendOfficeYn: this.userInput.recommendOfficeYn,
        companyNameKr: this.userInput.companyName.kr,
        companyNameEn: this.userInput.companyName.en,
        capital: parseInt(this.userInput.capital.replace(/,/g, '')) || 0,
        freeRegistrationYn: this.userInput.freeRegistrationYn,
        taxConsultingYn: this.userInput.taxConsultingYn,
        utilities: this.totalUtilities,
        requestType: this.userInput.requestType,
        address: this.userInput.address,
        registrationTax: this.registrationTax,
        feeAndTax: this.feeAndTax,
      });
    },

    setPaymentType(payment_type: number) {
      this.pay_type = payment_type === 1 ? 'card' : 'transfer';

      const cardBtn = document.querySelector('.payment-btn-card');
      const transferBtn = document.querySelector('.payment-btn-transfer');

      cardBtn?.classList.remove('active');
      transferBtn?.classList.remove('active');

      if (this.pay_type === 'card') {
        cardBtn?.classList.add('active');
      } else {
        transferBtn?.classList.add('active');
      }
    },

    async submit() {
      this.isLoading = true;
      this.feeAndTax = true;

      // 대기 중인 중간 저장은 버린다 — 큐를 타고 뒤늦게 도착해 최종 값을 되돌릴 수 있다.
      this.debouncedSave.clear();

      try {
        await this.save(true);
      } catch (e) {
        console.error('save failed', e);
        this.isLoading = false;
        alert('접수 처리 중 오류가 발생했습니다. 다시 시도해 주세요.');
        return;
      }

      this.initInput();

      document.location.href = '/request/complete';
    },

    async submit2() {
      if (this.pay_type !== 'card' && this.pay_type !== 'transfer') {
        alert('결제 방법을 선택해주세요.');
        return;
      }

      const getPaymentResult = async (res: any) => {
        console.log('[getPaymentResult]', res);
        if (res.PCD_PAY_RST === 'success') {
          this.isLoading = true;
          this.feeAndTax = true;
          this.debouncedSave.clear();
          try {
            await this.save(true);
          } catch (e) {
            console.error('save failed', e);
            this.isLoading = false;
            alert('접수 처리 중 오류가 발생했습니다. 다시 시도해 주세요.');
            return;
          }
          this.initInput();
          document.location.href = '/request/complete';
        }
      };

      const obj: Payple = {};

      obj.PCD_PAY_GOODS = '법인설립 수수료'; // (필수) 결제 상품
      obj.PCD_PAY_TOTAL = '500'; //(필수) 결제 금액 // 195800

      obj.PCD_PAY_TYPE = this.pay_type; // (필수) 결제 방법 (transfer | card)
      obj.PCD_PAY_WORK = 'PAY'; // (필수) 결제요청 업무구분 (AUTH : 본인인증+계좌등록, CERT: 본인인증+계좌등록+결제요청등록(최종 결제승인요청 필요), PAY: 본인인증+계좌등록+결제완료)
      obj.PCD_CARD_VER = '02'; // DEFAULT: 01 (01: 정기결제 플렛폼, 02: 일반결제 플렛폼), 카드결제 시 필수
      // obj.PCD_PAYER_AUTHTYPE = 'sms'; // (선택) [간편결제/정기결제] 본인인증 방식 (sms : 문자인증 | pwd : 패스워드 인증)                               // 인증파일경로 /절대경로/payple_auth_file (node.js => [app.js] app.post('/pg/auth', ...) {..}

      obj.callbackFunction = getPaymentResult;
      obj.PCD_PAYER_NO = this.userInput.recordId;
      obj.PCD_TAXSAVE_FLAG = 'Y'; // (선택) 현금영수증 발행여부
      obj.PCD_REGULER_FLAG = 'N'; // (선택) 정기결제 여부 (Y|N)
      obj.PCD_SIMPLE_FLAG = 'Y'; // (선택) 간편결제 여부 (Y|N)
      obj.PCD_PAYER_NAME = this.userInput.name; // (선택) 결제자 이름
      obj.PCD_PAYER_HP = this.userInput.hp; // (선택) 결제자 휴대폰 번호

      obj.clientKey = process.env.PAYPLE_CLIENT_KEY;

      window.PaypleCpayAuthCheck(obj);
    },

    openPopup() {
      this.isOpenPopup = true;
    },

    closePopup() {
      this.isOpenPopup = false;
    },

    exit() {
      this.initInput();

      document.location.href = '/';
    },
  };
}

export function step1Data() {
  return step1;
}

export function step2Data() {
  return step2;
}

export function step3Data() {
  return step3;
}

export function step4Data() {
  return step4;
}

export function step5Data() {
  return step5;
}

export function step6Data() {
  return step6;
}

export function step7Data() {
  return step7;
}

export function step8Data() {
  return step8;
}

export function step9Data() {
  return step9;
}

export function step10Data() {
  return step10;
}
